import React from "react";
import Section from "./section"

const EpKapitelueberschrift = props => {
  return (
    <Section
      baseClass="m-RichText"
      defaultPaddingTop="small"
      data={props.data}
    >
      <div className="m-RichText-wrapper">
        <div className="m-RichText-container">
          {props.data.headline && (
            <div className="dfb-Rte">
              <h5>{props.data.headline}</h5>
            </div>
          )}
        </div>
      </div>
    </Section>
  )
}

export default EpKapitelueberschrift
